import React, {useState} from 'react';
import useAuth from "../hooks/use-auth";
import {handleInputChange} from "../components/form/formHandler";
import { Link } from "react-router-dom";
import {Alert, AlertTitle, Button, TextField, Typography} from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2";
import {handleApiError} from "src/api/errorHandler";
import Box from "@mui/material/Box";
import PasswordField from "src/components/form/PasswordField";

const LoginPage = () => {
  const { onLogin } = useAuth();
  const [formValues, setFormValues] = useState({
    'email': '',
    'password': '',
  })
  const [formErrors, setFormErrors] = useState({});
  const [errorMessage, setErrorMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage('');
    setFormErrors({});

    try {
      await onLogin(
        formValues.email,
        formValues.password
      );
    } catch (e) {
      handleApiError(e, setFormErrors);
      setErrorMessage(e.response.data.message);
    }
  }

  return (
    <>
      <Typography variant="h2" mb={2}>Inloggen</Typography>
      <form>
        {errorMessage && (<Alert severity="error">{errorMessage}</Alert>)}
        <Grid2 container>
          <Grid2 xs={12}>
            <TextField
              value={formValues.email}
              name="email"
              label="E-mailadres"
              onChange={(e) => handleInputChange(e, formValues, setFormValues)}
              error={'email' in formErrors}
              helperText={formErrors.email}
              autoComplete='username'
              margin="dense"
              fullWidth
              required
            />
          </Grid2>

          <Grid2 xs={12}>
            <PasswordField
              value={formValues.password}
              name="password"
              type="password"
              label="Wachtwoord"
              onChange={(e) => handleInputChange(e, formValues, setFormValues)}
              error={'plainPassword' in formErrors}
              helperText={formErrors.plainPassword}
              autoComplete='new-password'
              margin="dense"
              fullWidth
              required
            />
          </Grid2>
        </Grid2>

        <Box mt={1} mb={3}>
          <Button
            type="submit"
            onClick={handleSubmit}
            variant="contained"
          >
            Inloggen
          </Button>
        </Box>

      </form>

      <p><Link to="/wachtwoord-vergeten">Wachtwoord vergeten?</Link></p>

      <p><Link to="/registreren">Registreren</Link></p>
    </>
  );
}

export default LoginPage;

LoginPage.propTypes = {}

LoginPage.defaultProps = {}